import { RevenueDashboardWorkspace } from "components/Dashboard/RevenueDashboardWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import AcresMapReport from "components/Reports/Vault/AcresMapReport";
import BalanceSheetReport from "components/Reports/Vault/BalanceSheetReport";
import BaseAcresReport from "components/Reports/Vault/BaseAcresReport";
import BudgetSummaryReport from "components/Reports/Vault/BudgetSummaryReport";
import ClaimsReport from "components/Reports/Vault/ClaimsReport";
import FarmsReport from "components/Reports/Vault/FarmsReport";
import FarmTractFieldReport from "components/Reports/Vault/FarmTractFieldReport";
import IncomeStatementReport from "components/Reports/Vault/IncomeStatementReport";
import InsuranceSummaryReportWorkspace from "components/Reports/Vault/InsuranceSummaryReportWorkspace";
import InsuredRevenueByFarmReport from "components/Reports/Vault/InsuredRevenueByFarm";
import ProducerAdvisoryReport from "components/Reports/Vault/ProducerAdvisoryReport";
import StressTestReport from "components/Reports/Vault/StressTestsReport";
import { WeatherDashboardWorkspace } from "components/Weather/WeatherDashboardWorkspace";
import { default as EmptyWorkspace } from "components/Workspaces/EmptyWorkspace";

import ClaimsAnalysisReport from "../components/Reports/Vault/ClaimsAnalysisReport";

export const reportsRoutes = [
  {
    path: "/reports/",
    element: <RouteLayout />,
    children: [{ index: true, element: <EmptyWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Report" />,
  },
  {
    path: "/reports/revenue-dashboard",
    element: <RouteLayout />,
    children: [{ index: true, element: <RevenueDashboardWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Revenue Dashboard" />,
  },
  {
    path: "/reports/yield-forecast",
    element: <RouteLayout />,
    children: [{ index: true, element: <WeatherDashboardWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Yield Forecast" />,
  },
  {
    path: "/reports/vault/stress-tests",
    element: <RouteLayout />,
    children: [{ index: true, element: <StressTestReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Stress tests" />,
  },
  {
    path: "/reports/vault/FarmReport/:crop_year",
    element: <RouteLayout />,
    children: [{ index: true, element: <EmptyWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Report" />,
  },
  {
    path: "/reports/vault/FarmsReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmsReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Report" />,
  },
  {
    path: "/reports/vault/BaseAcresReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <BaseAcresReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Base Acres Report" />,
  },
  {
    path: "/reports/vault/FarmTractFieldReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <FarmTractFieldReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Farm Report" />,
  },
  {
    path: "/reports/vault/AcresMapReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <AcresMapReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Acres Map Report" />,
  },
  {
    path: "/reports/vault/InsuranceSummaryReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuranceSummaryReportWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance Summary Report" />,
  },
  {
    path: "/reports/vault/BudgetSummaryReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetSummaryReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget Summary Report" />,
  },
  {
    path: "/reports/vault/BalanceSheet",
    element: <RouteLayout />,
    children: [{ index: true, element: <BalanceSheetReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Balance Sheet Report" />,
  },
  {
    path: "/reports/vault/ProducerAdvisory",
    element: <RouteLayout />,
    children: [{ index: true, element: <ProducerAdvisoryReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Producer Advisory Report" />,
  },
  {
    path: "/reports/vault/InsuredRevenueByFarmReport/:crop_year",
    element: <RouteLayout />,
    children: [{ index: true, element: <InsuredRevenueByFarmReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Insured Revenue By Farm Report" />,
  },
  {
    path: "/reports/vault/ClaimsReport",
    element: <RouteLayout />,
    children: [{ index: true, element: <ClaimsReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance Claims Report" />,
  },
  {
    path: "/reports/vault/ClaimsAnalysis",
    element: <RouteLayout />,
    children: [{ index: true, element: <ClaimsAnalysisReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Insurance Claims Analysis" />,
  },
  {
    path: "/reports/vault/IncomeStatement",
    element: <RouteLayout />,
    children: [{ index: true, element: <IncomeStatementReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Income Statement Report" />,
  },
];
